import { env } from '@/lib/env'

export const KEYCLOAK_CONFIG = {
  realm: env.NEXT_PUBLIC_KEYCLOAK_REALM,
  url: env.NEXT_PUBLIC_KEYCLOAK_URL,
  clientId: env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID,
}

/**
 * Sanitizes a callback URL to prevent open redirect attacks.
 * Only allows relative paths (starting with /) — rejects absolute URLs and protocol-relative URLs.
 */
export function sanitizeCallbackUrl(url: string | null | undefined, fallback = '/account/dashboard'): string {
  if (!url) return fallback

  const trimmed = url.trim()

  // Reject URLs with CRLF characters (prevents header injection if used in redirects)
  if (trimmed.includes('\n') || trimmed.includes('\r')) return fallback

  // Must start with a single "/" and NOT "//" (protocol-relative URL)
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed
  }

  return fallback
}
